// GrowthLane brand mark — green tile with ascending white bars (growth + lane)
export function Mark() {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#2f8f5b" />
      <rect x="8.5" y="17" width="3.6" height="7" rx="1.5" fill="#fff" />
      <rect x="14.2" y="12.5" width="3.6" height="11.5" rx="1.5" fill="#fff" />
      <rect x="19.9" y="8" width="3.6" height="16" rx="1.5" fill="#fff" />
    </svg>
  )
}
